import itemsDuck from './ducks/items';
import queryDuck from './ducks/query';

export { getStoreId } from '@/features/storePage/selectors';

export const {
  getError,
  getItemsIds,
  getItemsMeta,
  getItemsTotalCount,
  isLoadingItems,
} = itemsDuck.selectors;

export const { getFilters, getPage, getLimit, getSort } = queryDuck.selectors;
